module.exports = __webpack_public_path__ + "static/media/gift-card-image.e3dfcbf4.png";